import { AIResponse, AITaskResponse } from '@honeybook/ai-core';
import { ITestStreamingProvider } from '../types/testing-types';
import { TestCommunicationProtocol } from '@honeybook/ai-core/testing';

export type StreamingProviderOptions = {
    delayedStart?: number;
};

export class TestStreamingProvider implements ITestStreamingProvider {
    private awaitingResponsesBuffer: AITaskResponse[] = [];
    private signalOnNewResponses: (() => void) | null = null;
    private readonly ai_task_id: string;
    private isStopped = false;

    static streamingProviders: Record<string, TestStreamingProvider> = {};

    constructor(protocol: TestCommunicationProtocol) {
        this.ai_task_id = protocol.data.ai_task_id;
    }

    async start(): Promise<void> {
        this.isStopped = false;
        TestStreamingProvider.streamingProviders[this.ai_task_id] = this;
    }

    async stop(): Promise<void> {
        this.isStopped = true;
        delete TestStreamingProvider.streamingProviders[this.ai_task_id];
    }

    streamResponse(message: AIResponse): void {
        if (this.isStopped) {
            return;
        }

        // Create AITaskResponse with the provided message
        const taskResponse: AITaskResponse = {
            ai_task_id: this.ai_task_id,
            feature: 'test-feature',
            status: 'active',
            responses: [message]
        };

        this.awaitingResponsesBuffer.push(taskResponse);
        this.signalOnNewResponses?.();
    }

    streamMessages(messages: AIResponse[]): void {
        if (this.isStopped) {
            return;
        }

        // Create AITaskResponse with the provided messages
        const taskResponse: AITaskResponse = {
            ai_task_id: this.ai_task_id,
            feature: 'test-feature',
            status: 'active',
            responses: messages
        };

        this.awaitingResponsesBuffer.push(taskResponse);
        this.signalOnNewResponses?.();
    }

    async *stream(): AsyncGenerator<AITaskResponse, void, unknown> {
        while (true) {
            if (this.awaitingResponsesBuffer.length === 0) {
                // Nothing ready yet - wait for next push
                await new Promise<void>(resolve => {
                    this.signalOnNewResponses = resolve;
                });
                continue;
            }

            yield this.awaitingResponsesBuffer.shift();
        }
    }
}
